import { storeEvent } from "_analytics/index";

import Presentation from "./presentation";

const CreatorCard = ( { data } ) => {

	const handleGAEvent = type => {
		storeEvent ( "Profile", type, "Game_Card" );
	};

	return (
		<Presentation data = { data }
			handleGAEvent     = { handleGAEvent }
		/>
	);
};

export default CreatorCard;